import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import EmployeeFormScreen from "@/pages/employees/components/EmployeeFormScreen";

export default function EmployeeEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { employees } = useStore();
  const [searchParams] = useSearchParams();

  const employee = employees.find((item) => item.id === id) ?? null;
  const focus =
    searchParams.get("focus") === "permissions"
      ? ("permissions" as const)
      : null;

  if (!employee) {
    return (
      <div className="yc-fade-up bg-white rounded-card border border-background-200 shadow-card px-8 py-20 text-center">
        <div className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
          <i className="ri-user-line text-3xl"></i>
        </div>
        <h2 className="text-lg font-bold text-foreground-950">
          الموظف غير موجود
        </h2>
        <p className="mt-1 text-sm text-foreground-500">
          تعذّر العثور على الموظف المطلوب، ربما تم حذفه.
        </p>
        <button
          type="button"
          onClick={() => navigate("/employees")}
          className="mt-5 inline-flex items-center gap-2 rounded-btn bg-primary-500 px-5 py-2.5 text-sm font-semibold text-white hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-arrow-right-line"></i>
          العودة للموظفين
        </button>
      </div>
    );
  }

  return <EmployeeFormScreen employee={employee} focus={focus} />;
}